
import React, { useState, useEffect } from 'react';
import { Popconfirm, Table, Button, message, Form, Modal, Space } from 'antd';
import { DeleteFilled, PlusOutlined, EditOutlined } from '@ant-design/icons';
import { withApollo } from 'react-apollo';
import MedicationAddForm from './medicationAddForm';



const Medications = (props) => {

  const [data, setdata] = useState([])
  const [visible, setvisible] = useState(false);
  const [selected, setselected] = useState(null);
  const [searched, setsearched] = useState(false);
  const [query, setquery] = useState('');
  const [groupedData, setgroupedData] = useState(null);


  useEffect(() => {
    if(props.form){
      let values = props.form.getFieldsValue();
      if(values.medication != null){
        let obj = values.medication.map((a)=>{
          delete a['__typename']
          return{...a}
        })
        setdata(obj)
        createGroupedData(obj)
      }
    }
   }, [])


   const createGroupedData=(res)=>{
    if (res.length > 0) {
      let obj = new Object();
      let arr = []
      res.map((a) => {
        if (obj.hasOwnProperty(a.genericName)) {
          // a.key = a.genericName;
          obj[a.genericName].push(a);
          let index = arr.findIndex((item) => item.title == a.genericName);
          let item = arr[index];

          if (item) {
            item.group.push(a)
            // item.diagnosisSet.push(`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`)
            arr.splice(index, 1, item)
          }
        } else {
          obj[a.genericName] = [a];
          arr.push({
            title: a.genericName,
            group: [a],
            key: a.genericName,
            // diagnosisSet: [`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`]
          })
        }
      })
      setgroupedData(arr)
      // setdata(res);
      // if(searched == true){
      //   let arr1 = arr.filter((item) => {
      //     let filters = item.diagnosisSet.filter((a) => {
      //       if (a.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1) {
      //         return a
      //       }
      //     });
  
      //     if (
      //       item.title.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1
      //       ||
      //       filters.length > 0
      //     ) {
      //       return item
      //     }
      //   })
      //   // setsearchedData(arr1)
      // }
    }
   }



  const deleteItem = (record, i) => {
    let arr = [...data]
    let index = arr.findIndex((a)=>a.genericName == record.genericName && a.brandName == record.brandName)
 
   if(index<0){
    return
   }
    arr.splice(index, 1);
    setdata(arr)
    createGroupedData(arr)
    if(props.form){
      props.form.setFieldsValue({
        medication: arr
      })
    }
    message.success('Medication deleted successfully')
  }


  const deleteBrandName = (record, i) => {
    let arr = [...data]
    let index = arr.findIndex((a)=>a.genericName == record.genericName && a.brandName == record.brandName)
 
   if(index<0){
    return
   }
    let item = arr[index];
    item.brandName = undefined;
    delete item['key'];
    arr[index]=item;
    setdata(arr)
    createGroupedData(arr)
    if(props.form){
      props.form.setFieldsValue({
        medication: arr
      })
    }
    message.success('Brand name deleted successfully')
  }


    const columns1 = [
      {
        title: 'Generic Name',
        dataIndex: 'title',
        key: 'title',
        // width: '10%'
      }
    ];

  const columns = [
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      key: 'brandName',
      width: '10%'
    },
    {
      title: 'Generic Name',
      dataIndex: 'genericName',
      key: 'diagnosisName',
      width: '10%'
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency',
      width: '10%'
    },
    {
      title: 'Dosage',
      dataIndex: 'dosage',
      key: 'dosage',
      width: '10%'
    },
    {
      title: 'Dosage Unit',
      dataIndex: 'dosageUnit',
      key: 'dosageUnit',
      width: '5%'
    },
    {
      title: 'ROA',
      dataIndex: 'roa',
      key: 'roa',
      width: '5%'
    },
    {
      title: 'Duration in Days',
      dataIndex: 'duration',
      key: 'duration',
      width: '10%',
      render: (text, record) => {
        return (
          <span>{record.duration}</span>
        )
      }
    },
    // {
    //   title: 'Dosage Date',
    //   dataIndex: 'dosageDate',
    //   key: 'dosageDate',
    //   width: '10%',
    //   render: (text, record) => {
    //     let ddate = record.dosageDate
    //     return (
    //       <>
    //         <span>{ddate != null && moment(ddate[0]).format('DD-MM-YYYY')}</span>
    //         <span> - </span>
    //         <span>{ddate != null && moment(ddate[1]).format('DD-MM-YYYY')}</span> 
    //       </>
    //     )
    //   }
    // },
    // {
    //   title: 'Instructions',
    //   dataIndex: 'instruction',
    //   key: 'instruction',
    //   width: '10%'
    // },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'action',
      width: '5%',
      render: (text, record, i) => {
        return (
          <Space>
          
            <Button type="link" 
            onClick={()=>{
              setselected(record)
              setvisible(true)
            }}>
              <EditOutlined/>
            </Button>

            <Popconfirm
            title="Are you sure?"
            onConfirm={() => { deleteBrandName(record, i) }}
            okText="Yes"
            cancelText="No">
            <Button type="link">
              Delete Brand Name
            </Button>
          </Popconfirm>
        
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => { deleteItem(record, i) }}
            okText="Yes"
            cancelText="No">
            <Button type="link">
              <DeleteFilled />
            </Button>
          </Popconfirm>
          </Space>
        )
      }
    }
  ];

  const copyToClipboard=(e)=>{
    var text = JSON.stringify({data:data})
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    elem.value = text;
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
    message.success('Copied!')
  }


  const pasteAllData=()=>{
    navigator.clipboard.readText()
    .then(text => {
      console.log('Pasted content: ', JSON.parse(text));
      let copiedText = JSON.parse(text);

      if(copiedText && copiedText.data){
        let arr = [...copiedText.data, ...data]
        // arr = arr.filter((x, i, a) => a.indexOf(x) == i)
        
//         let mymap = new Map();
  
//         let unique = arr.filter(el => {
//             const val = mymap.get(el.genericName);
         
//             if(val) {
//                 if(el.id < val) {
//                   console.log('in',el)
//                     mymap.delete(el.genericName);
//                     mymap.set(el.genericName, 20);
//               return true;
//                 }else{
                  
//                     return false;
//                 }
//             }
// console.log('else',el)
//               mymap.set(el.genericName, 10);
//               return true;
            
          
//         });
          
        // console.log(unique, arr);


        const array = arr
         
         let m = unique(array, ['genericName'])
       
         function unique(arr, keyProps) {
          const kvArray = arr.map(entry => {
           const key = keyProps.map(k => entry[k]).join('|');
           return [key, entry];
          });
          const map = new Map(kvArray);
          return Array.from(map.values());
         }

        setdata(m)
        createGroupedData(m)
        if(props.form){
          props.form.setFieldsValue({
            medication: m
          })
        }
      }

    })
    .catch(err => {
      console.error('Failed to read clipboard contents: ', err);
    })
  }

  const expandedRowRender = (res) => {
    return <Table style={{ width: '100%' }} size="small" bordered 
    columns={columns} dataSource={res.group} pagination={false} />;
  }

  return (
    <>
    <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row-reverse', marginBottom: '10px' }}>
      <Space>
        <Button id='addMedicationPlusBtn' type="primary" onClick={() => {
          setvisible(true)
        }}><PlusOutlined /></Button>

        <Button id='medicationCopyBtn' onClick={()=>{
          copyToClipboard()
        }}>
          Copy
        </Button>

        <Button id='medicationPasteBtn' onClick={()=>{
          pasteAllData()
        }}>
          Paste
        </Button>

      </Space>

      </div>
  
      <Table 
      size="small" 
      expandable={{ expandedRowRender }} 
      style={{ width: '100%' }} 
      columns={columns1} 
      dataSource={groupedData} />
      <Modal
        maskClosable={false}
        visible={visible}
        onOk={() => {
          setvisible(false)
          setselected(null)
        }}
        onCancel={() => {
          setvisible(false)
          setselected(null)
        }}
        destroyOnClose
        width={'70%'}
        footer={false}
        closeIcon={<span id="closeGeneric">X</span>}
      >
        <MedicationAddForm 
        record={selected}
        setMainData={(val) => {

          let arr = [...data];
          let i = arr.findIndex((a)=>a.genericName == val.genericName && a.brandName == val.brandName);

          if(i != -1){
            let item = arr[i];
            item = {...val}
            arr.splice(i,1,item)
          }else{
            arr.splice(0,0,val)
          }
       
            setdata(arr)
            createGroupedData(arr)
            // setvisible(false)
            setselected(null)
            if(props.form){
              props.form.setFieldsValue({
                medication: arr
              })
            }

        }} />
      </Modal>
      <Form.Item name="medication">
      </Form.Item>
   
    </>
  )
}

export default withApollo(Medications)